var _ = require('underscore');
var Backbone = require('backbone');

var AdaptedCollection = Backbone.Collection.extend({
  adapt: function(model, options){ return model },

  adaptList: function(models, options) {
    var adaptModel = function(model){return this.adapt(model, options);}.bind(this);
    return _.map(models, adaptModel);
  },
  set: function(models, options) {
    var list = models;
    if(!_.isArray(models)) list = [models]
    var items = this.adaptList(list, options);
    return Backbone.Collection.prototype.set.call(this, items, options)
  },

  /*
    Note: Backbone already delegates these methods to set():
      add
      push
      unshift
      reset
    So no need to override them in order to adapt the model.
  */

});

export default AdaptedCollection;